export const brl = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
    Number(v || 0)
  );

export const pct = (v, digits = 2) =>
  new Intl.NumberFormat("pt-BR", {
    style: "percent",
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(Number(v || 0));

export const num = (v, digits = 0) =>
  new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: digits,
    maximumFractionDigits: 2,
  }).format(Number(v || 0));

/** "25,22" | "25.22" -> 0.2522 */
export const parsePctInput = (s) => {
  if (s === "" || s === null || s === undefined) return 0;
  const n = parseFloat(String(s).replace(",", "."));
  if (Number.isNaN(n)) return 0;
  return n / 100;
};

/** 0.2522 -> "25,22" */
export const toPctInput = (f, digits = 2) => {
  const n = Number(f || 0) * 100;
  const s = digits === 0 ? String(Math.round(n)) : n.toFixed(digits);
  return s.replace(/\.?0+$/, "").replace(".", ",") || "0";
};

export const dataHora = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "—";
  }
};

export const dataCurta = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("pt-BR");
  } catch {
    return "—";
  }
};

/**
 * Formata uma data "somente data" (ex.: "2026-08-18", vinda de um
 * <input type="date">, SEM horário/timezone) para "DD/MM/AAAA".
 *
 * Importante: NÃO usa `new Date(str)` — strings tipo "AAAA-MM-DD" são
 * interpretadas pelo JS como meia-noite UTC, e ao converter para o horário
 * local do navegador (ex.: Brasília, UTC-3) o dia "volta" incorretamente
 * (ex.: 18/08 exibido como 17/08). Aqui formatamos direto pelos componentes
 * da string, sem qualquer conversão de fuso horário.
 */
export const dataSomente = (str) => {
  if (!str) return "—";
  const m = String(str).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return "—";
  const [, ano, mes, dia] = m;
  return `${dia}/${mes}/${ano}`;
};
